export default function formatVideoDuration(duration) {
  const roundedDuration = Math.round(duration);
  const minutes = Math.floor(roundedDuration / 60);
  const seconds = roundedDuration % 60;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${formattedSeconds}`;
}
